module.exports = __webpack_public_path__ + "static/media/img2-3.d5eb2fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/biosense/diff/img2-3.png
// module id = 1897
// module chunks = 3